







































































































































import {
  Component, Prop, Vue, PropSync, Watch,
} from 'vue-property-decorator';
import { cloneDeep } from 'lodash';
import {
  Unit, Settings, User, UnitsApi,
} from '@compassdigital/foodworks.ts.sdk';
import AppModule from '@/store/modules/app';
import UnitInformation from '@/components/Form/Unit/UnitInformation/index.vue';
import EditConfirmation from '@/components/Form/EditConfirmation/index.vue';
import StandardCard from '@/components/Card/StandardCard/index.vue';
import UnitsUtil from '@/util/UnitUtil';
import Format from '@/util/Format';
import UserModule from '@/store/modules/user';

@Component({
  components: {
    StandardCard,
    UnitInformation,
    EditConfirmation,
  },
})
export default class UnitContactDetail extends Vue {
  @PropSync('unitDetails', {}) unitInfo!: Unit;

  @PropSync('marketList', {}) marketSync!: any;

  @PropSync('sectorList', {}) sectorSync!: any;

  @PropSync('scoutList', {}) scoutSync!: any;

  @PropSync('marketID', {}) marketIDSync!: any;

  @PropSync('scoutUserInfo', {}) scoutUserStatus!: Unit;

  public edit: boolean = false;

  public loading: boolean = false;

  public cachedUnitInfo: any | null = null;

  public onClickEdit() {
    this.cachedUnitInfo = cloneDeep(this.unitInfo);
    this.edit = true;
    this.$emit('on-edit-button', this.edit);
  }

  public async onCancel() {
    if (this.cachedUnitInfo) {
      (this.unitInfo as any) = cloneDeep(this.cachedUnitInfo);
      this.unitInfoLocal = cloneDeep(this.cachedUnitInfo);
    }
    this.edit = false;
    this.$emit('on-edit-button', this.edit);
  }

  @Watch('unitInfo', { immediate: true })
  onContactInfoChanged(val: any) {
    this.unitInfoLocal = val;
  }

  public unitInfoLocal: any | null = null;

  get phoneNumber() {
    if (this.unitInfoLocal) {
      const { phone } = this.unitInfoLocal.phone;
      return Format.maskPhoneNumber(phone);
    }
    return '';
  }

  get unitManagerPhone() {
    const { phone } = this.unitInfoLocal.unitUser.phone;
    if (phone) {
      return Format.maskPhoneNumber(phone);
    }
    return '';
  }

  get scoutPhone() {
    const { phone } = this.unitInfoLocal.scoutDetails.phone;
    if (phone) {
      return Format.maskPhoneNumber(phone);
    }
    return '';
  }

  get addressLine() {
    let line = '';
    if (this.unitInfoLocal) {
      const {
        address: {
          address, city, state, country, zip,
        },
      } = this.unitInfoLocal;

      line = `${address} </br> ${city}, ${state} ${zip}</br> ${country}`;
    }
    return line;
  }

  public async onSave() {
    if (
      (this.$refs.form as any).validate()) {
      this.loading = true;
      const unitInfo: any = { ...this.unitInfo };
      if (unitInfo.compassUnitId) {
        unitInfo.compassUnitId = parseInt(unitInfo.compassUnitId, 10);
      }

      if (unitInfo.phone.phone) {
        const { phone } = unitInfo.phone;
        unitInfo.phone.phone = Format.CheckMaskNumber(phone);
      }
      if (unitInfo.phone.ext) {
        unitInfo.phone.ext = parseInt(unitInfo.phone.ext, 10);
      } else {
        delete unitInfo.phone.ext;
      }

      if (!unitInfo.scoutUserId) {
        unitInfo.scoutUserId = unitInfo.scoutFirstID;
      }

      try {
        const unitData: Unit = {
          id: unitInfo.id,
          compassUnitId: unitInfo.compassUnitId,
          name: unitInfo.name,
          address: unitInfo.address,
          phone: unitInfo.phone,
          sectorId: unitInfo.sectorId,
          marketId: unitInfo.marketId,
          scoutUserId: unitInfo.scoutUserId,
          managerUserId: unitInfo.managerUserId,
          active: unitInfo.active,
        };
        if (UserModule.currentRole === 'unit_manager') {
          delete unitData.marketId;
          delete unitData.scoutUserId;
        }
        const api = new UnitsApi(AppModule.apiConfig);
        const unitUser = await api.patchUnitById(unitInfo.id, unitData);
        const unit = await api.getUnitById(unitUser.data.id as string);
        const data = await UnitsUtil.mappedDetailsUnit(
          unit.data,
          this.marketSync,
          this.scoutSync,
          this.sectorSync,
        );
        if (data) {
          (this.unitInfo as any) = cloneDeep(data);
        }
        this.marketIDSync = unit.data.marketId;
        this.edit = false;
        this.$emit('on-edit-button', this.edit);
      } catch (err) {
        console.log('err', err.response.data);
      }
      this.loading = false;
    }
  }

  get accessAdminUser() {
    if (UserModule.currentRole === 'fw_admin'
    || UserModule.currentRole === 'fw_manager'
    || UserModule.currentRole === 'unit_manager'
    ) {
      return UserModule.currentRole;
    }
    return null;
  }
}
